import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '@material-ui/core/Button';
import {withRouter} from 'react-router-dom';

import convert from 'xml-js';

import { connectProps } from 'store';
import { updateUserID, updateEmail } from 'model/component-props';

import { styles } from './style';

class LoginCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            showPassword: false,
            checkedA: false,
            loginmessage: ''
        }
        this.onSubmitLogIn = this.onSubmitLogIn.bind(this);
    }

    componentDidMount(){
        document.addEventListener("keydown", this.onkeyPress, false);
    }

    onEmailChange = event => {
        this.setState({ username: event.target.value });
    };

    onPasswordChange = event => {
		this.setState({ password: event.target.value})
	}

    handleChangeCheck = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };

    clearstate = () => {
        this.setState({
            loginmessage: ''
        })
    };

    onSubmitLogIn = () => {

        const username = this.state.username;
        const password = this.state.password;
        const login = `${username}|${password}`;
        let dataAsJson = {};

        fetch(`${process.env.REACT_APP_NODE_SERVER}/login`, {
            crossDomain: true,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "data": {"username": login },
                username: this.state.username
              }),
        })
        .then(response => response.text())
        .then(str => {  
            dataAsJson = convert.xml2json(str);
        }).then(() => {
            const data = JSON.parse(dataAsJson);
            console.log(data);
            const ID = data['elements'][0].elements[0].elements[0].elements[0].elements[0].text;
            if(ID === "EMPTY"){
                this.setState({
                    loginmessage: 'Enter username and password!'
                })
            }
            else if(ID === 'NOTFOUND'){
                this.setState({
                    loginmessage: 'Wrong username!'
                })
            }
            else if(ID === 'WRONGPASS'){
                this.setState({
                    loginmessage: 'Wrong Password'
                })
            }
            else {
                window.sessionStorage.setItem('userID', ID);
                this.props.updateUserID(ID);
                const isCustomer = data['elements'][0].elements[0].elements[0].elements[1].elements[0].text;
                if(isCustomer === "false") {
                    this.props.updateEmail('')
                    this.props.history.push('/home');
                }
                else {
                    this.props.updateEmail(this.state.username)
                    this.props.history.push('/collections');
                }
                
            }
        });
    }


    render() {
        const { classes } = this.props;

        return (
            <Card className={classes.card}>
                <CardContent>
                    <div className={classes.title}>Login</div>
                    <FormControl className={classes.textfields} >
                        <InputLabel htmlFor="component-simple">Username</InputLabel>
                        <Input onClick={this.clearstate}
                          id="component-simple"
                          value={this.state.username}
                          onChange={this.onEmailChange}
                          onKeyPress={(ev) => {
                            if (ev.key === 'Enter') {
                                this.onSubmitLogIn();
                                ev.preventDefault();
                            }
                          }}  />
                    </FormControl>
                    <br />
                    <FormControl className={classes.textfields} >
                        <InputLabel htmlFor="adornment-password">Password</InputLabel>
                        <Input
                          onClick={this.clearstate}
                          id="adornment-password"
                          type={this.state.showPassword ? 'text' : 'password'}
                          value={this.state.password}
                          onChange={this.onPasswordChange}
                          onKeyPress={(ev) => {
                            if (ev.key === 'Enter') {
                                this.onSubmitLogIn();
                                ev.preventDefault();
                            }
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                  aria-label="Toggle password visibility"
                                  onClick={this.handleClickShowPassword}
                                >
                                {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                            }
                        />
                    </FormControl>
                    {/*<div className={classes.checkBox}>
                        <Checkbox
                          checked={this.state.checkedA}
                          onChange={this.handleChangeCheck('checkedA')}
                          value="checkedA"
                          color="primary"
                        />
                        Remember me
                    </div>*/}
                    <div className={classes.buttons}>
                        {/*<Button className={classes.buttonA}>Forgot Password?</Button>*/}
                        <Button
                          className={classes.buttonB}
                          onClick={() => this.onSubmitLogIn()}>
                            Login
                        </Button>
                    </div>
                </CardContent>
                <div className={classes.loginmessage}>{this.state.loginmessage}</div>
            </Card>
        );
    }
}

LoginCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connectProps(updateUserID, updateEmail)(withRouter(withStyles(styles)(LoginCard)));



// WEBPACK FOOTER //
// ./src/components/logincard/LoginCard.js